import { useTabs } from "../../hooks/useTabs";
import { useIsMobile } from "../../hooks/useIsMobile";
import { DesktopTabContent } from "./DesktopTabContent";
import { MobileTabContent } from "./MobileTabContent";

export default function TabContent({ notes, studentId }) {
  const { noteStates, noteTotal, isAdmin, handleNoteChange, handleSubmit } =
    useTabs(notes, studentId);
  const isMobile = useIsMobile();
  return (
    <div className="w-full p-4">
      {isMobile ? (
        <MobileTabContent
          noteStates={noteStates}
          noteTotal={noteTotal}
          isAdmin={isAdmin}
          handleNoteChange={handleNoteChange}
        />
      ) : (
        <DesktopTabContent
          noteStates={noteStates}
          noteTotal={noteTotal}
          isAdmin={isAdmin}
          handleNoteChange={handleNoteChange}
        />
      )}

      <div className="mt-4">
        <button
          type="submit"
          className="px-4 py-2 bg-primary-validate text-white rounded-md hover:bg-secondary-validate"
          onClick={handleSubmit}
        >
          Valider
        </button>
      </div>
    </div>
  );
}
